var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPokemonLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.34 1333.07",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:#fff;fill-rule:nonzero}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1473324886368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Down",
    className: "fil0",
    d: "M666.54 885.24c-105.31 0-193.15-74.56-214.01-173.61H102.19c24.77 288.04 266.41 514.04 560.7 514.04 294.3 0 536.2-226 560.7-514.04H880.55c-20.85 99.32-108.7 173.61-214.01 173.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_Down",
    d: "M791.66 1211.07c233.56-54.74 411.08-254.68 431.94-499.44h-138.16c-13.81 222.09-130.34 410.3-293.78 499.44z",
    fill: "#dfdfdf",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Center",
    className: "fil0",
    d: "M795.57 666.54c-.26 0-.26 0 0 0-.26-15.9-3.13-31.02-8.34-45.09-18.25-49.01-65.43-83.68-120.69-83.68-55.26 0-102.44 34.93-120.69 83.68a129.312 129.312 0 00-8.08 45.09h.26c0 15.9 2.87 31.02 8.08 45.09 18.25 49.01 65.43 83.68 120.69 83.68 55.26 0 102.44-34.93 120.69-83.68 5.21-13.82 8.08-29.19 8.08-45.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Up",
    d: "M666.8 448.09c105.31 0 193.15 74.56 214.01 173.61h350.34c-24.76-288.3-266.41-514.3-560.96-514.3-294.56 0-535.94 226-560.7 514.04h343.3c20.85-99.06 108.7-173.35 214.01-173.35z",
    fill: "#ff1c1c",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_Up",
    d: "M1085.44 621.44h145.45C1209.52 372.5 1026 169.7 786.45 119.38c166.31 87.84 284.91 277.87 298.99 502.06z",
    fill: "#df1818",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M670.19 107.4c294.56 0 536.2 226 560.7 514.04H880.55c-20.85-99.06-108.7-173.61-214.02-173.61-105.31 0-193.15 74.56-214.01 173.61H109.48c24.76-288.05 266.41-514.04 560.7-514.04zm117.04 514.04c5.21 14.07 8.08 29.19 8.08 45.09h.26c0 15.9-2.87 31.02-8.08 45.09-18.24 49.01-65.43 83.68-120.69 83.68-55.26 0-102.44-34.93-120.69-83.68a129.312 129.312 0 01-8.08-45.09h-.26c0-15.9 2.87-31.02 8.08-45.09 18.24-49.01 65.43-83.68 120.69-83.68 55.26 0 102.44 34.93 120.69 83.68zm-124.34 604.49c-294.56 0-536.2-226-560.7-514.04h350.34c20.85 99.05 108.7 173.61 214.01 173.61 105.31 0 193.16-74.56 214.02-173.61h343.3c-24.76 287.78-266.41 514.04-560.96 514.04zM666.54 0C298.47 0 0 298.46 0 666.54c0 368.07 298.47 666.54 666.54 666.54 368.07 0 666.8-298.21 666.8-666.54S1034.87 0 666.54 0z",
    fill: "#000",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokemonLogo);
export default __webpack_public_path__ + "static/media/pokemonLogo.664cf7a38db5a97ef6d4c8dc563e5fa4.svg";
export { ForwardRef as ReactComponent };